<script lang="ts">
  import { profilStore } from '../stores/profil.store';
</script>

<div class="conteneur-zone-indentification">
  {#if $profilStore === undefined}
    <dsfr-button kind="tertiary-no-outline" markup="a" href="/inscription" size="sm" data-themeable="false"
      >S’inscrire</dsfr-button
    >
    <dsfr-button
      kind="tertiary-no-outline"
      markup="a"
      href="/connexion"
      size="sm"
      has-icon
      icon="user-line"
      data-themeable="false"
    >
      Se connecter
    </dsfr-button>
  {:else}
    <dsfr-user
      kind="tertiary-no-outline"
      expandable
      has-icon
      icon="account-circle-line"
      buttonLabel="{$profilStore.prenom} {$profilStore.nom}"
      id="utilisateur"
      button-id="utilisateur-btn"
      collapse-id="nav-utilisateur"
      hasLogout
      onlogout={() => (window.location.href = '/oidc/deconnexion')}
    >
    </dsfr-user>
  {/if}
</div>

<style lang="scss">
  * {
    box-sizing: border-box;
  }

  .conteneur-zone-indentification {
    display: flex;
    align-items: center;
  }
</style>
